
import { AuthStore } from './stores/authStore';
import {UsersStore} from "./stores/usersStore";
import {OrdersStore} from "./stores/ordersStore";
import {BrandsStore} from "./stores/brandsStore";
import {MenuStore} from "./stores/menuStore";
import {UsersRequestsStore} from "./stores/usersRequestsStore";
import {DealsStore} from "./stores/dealsStore";
import {PickupsStore} from "./stores/pickupsStore";

export const stores = {
    authStore: new AuthStore(),
    usersStore: new UsersStore(),
    usersRequestsStore: new UsersRequestsStore(),
    ordersStore: new OrdersStore(),
    brandsStore: new BrandsStore(),
    menuStore: new MenuStore(),
    dealsStore: new DealsStore(),
    pickupsStore: new PickupsStore(),
};